module.exports = __webpack_public_path__ + "img/face_img-03.1c98eb64.png";